import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const faqData = [
  {
    question: "What is a book trailer?",
    answer: "A book trailer is a short promotional video, typically 60-90 seconds, that presents your book as a visual narrative similar to a movie trailer. It's used on social media, author websites, and book marketing campaigns to attract readers and generate interest. Professional book trailers combine cinematic visuals, music, and text to capture the essence of your story."
  },
  {
    question: "How do I pitch my book to Hollywood?",
    answer: "To pitch your book to Hollywood and film studios, you need professional pitch materials that demonstrate your story's cinematic potential. This includes a book trailer or concept video showing key scenes, a design bible with character designs and visual style, and a proof-of-concept reel. Visual materials communicate more effectively than written pitches alone."
  },
  {
    question: "What is a design bible for books?",
    answer: "A design bible (also called a visual development bible or look book) is a comprehensive visual reference document for book-to-film adaptation. It includes character designs, setting concepts, color palettes, mood boards, and style direction that help film studios understand your book's cinematic potential."
  },
  {
    question: "How much does a book trailer cost?",
    answer: "Book trailer costs vary based on production quality and complexity. Basic trailers using stock footage start around $500-1,500, while professional cinematic trailers with custom footage typically range from $3,000-15,000+. Contact us for a custom quote tailored to your specific needs."
  },
  {
    question: "What are book-to-film pitch materials?",
    answer: "Book-to-film pitch materials are professional visual assets that help authors pitch their books to film studios, production companies, and streaming platforms. These include book trailers, concept trailers, design bibles, character artwork, and proof-of-concept scene reels."
  },
  {
    question: "How long does it take to create a book trailer?",
    answer: "Timeline varies based on complexity. A basic book trailer can be completed in 2-4 weeks, while a full cinematic concept trailer with custom footage may take 6-12 weeks. Design bibles typically require 3-6 weeks depending on the scope of visual development needed."
  }
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 px-4 bg-[#061018] relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="abstract-blob animate-float" style={{ 
          top: '20%', 
          right: '10%', 
          width: '400px', 
          height: '400px', 
          background: 'radial-gradient(circle, rgba(255, 101, 0, 0.2), transparent 70%)',
          filter: 'blur(80px)'
        }}></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Frequently Asked <span className="text-[#FF6500]">Questions</span>
          </h2>
          <p className="text-lg text-[#aaa] max-w-2xl mx-auto">
            Common questions about book trailers, film pitches, and visual development for authors.
          </p>
        </div>

        <div className="space-y-4">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-[#0a1525] border border-[#152840] rounded-lg overflow-hidden hover:border-[#FF6500]/30 transition-colors duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left"
              >
                <h3 className="text-lg font-medium text-white pr-4">{faq.question}</h3>
                {openIndex === index ? (
                  <ChevronUp className="w-5 h-5 text-[#FF6500] flex-shrink-0" />
                ) : (
                  <ChevronDown className="w-5 h-5 text-[#aaa] flex-shrink-0" />
                )}
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-5">
                  <p className="text-[#aaa] leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
